import { createFileRoute } from "@tanstack/react-router"
import { DeviceProfileDetail } from "@/components/sensory"

export const Route = createFileRoute("/sensory/device-profiles/$deviceProfileNumber")({
  staticData: {
    title: 'Device Profile Detail',
    isSecured: true,
  },
  component: DeviceProfileDetailPage,
})

function DeviceProfileDetailPage() {
  const { deviceProfileNumber } = Route.useParams()

  return (
    <div className="p-6">
      <DeviceProfileDetail deviceProfileNumber={parseInt(deviceProfileNumber)} />
    </div>
  )
}
